export type Brand = "EC";

export const BRANDS = {
  EC: "EC",
} as const satisfies Record<Brand, Brand>;

export type BrandId = (typeof BRANDS)[keyof typeof BRANDS];
